import { render } from "./channelEdit.vue?vue&type=template&id=640e10b6"
import script from "./channelEdit.vue?vue&type=script&lang=js"
export * from "./channelEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/enterPriseConfig/components/channelEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "640e10b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('640e10b6', __exports__)) {
    console.log('reload')
    api.reload('640e10b6', __exports__)
  }
  
  module.hot.accept("./channelEdit.vue?vue&type=template&id=640e10b6", () => {
    console.log('re-render')
    api.rerender('640e10b6', render)
  })

}


export default __exports__